// extracted by mini-css-extract-plugin
export var container = "index-module--container--JNYAu";
export var content = "index-module--content--tJiT1";
export var linkButton = "index-module--linkButton--pv831";